__turbopack_context__.v({
  "activeItem": "KUpw6G_activeItem",
  "gridList": "KUpw6G_gridList",
  "highlight-result": "KUpw6G_highlight-result",
  "list": "KUpw6G_list",
  "listItem": "KUpw6G_listItem",
  "result": "KUpw6G_result",
  "title": "KUpw6G_title",
});
